/**
 * CartTimer.jsx
 * Created by Destin Frasier on 7/26/17.
 * Enhancements added by Betty Huang on 8/10/17.
 */

import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import {pluralize} from '../../helpers/stringHelper';
import announce from '../../helpers/announce';

import * as Icons from './icons/Icons';

const propTypes = {
    date: PropTypes.instanceOf(Date).isRequired,
    onComplete: PropTypes.func
};

export default class CartTimer extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            timeRemaining: 0
        };

        this.tick = this.tick.bind(this);
    }

    componentDidMount() {
        this.tick();
        this.timer = setInterval(() => this.tick(), 1000);
        const announceTimerMessage = `You have ${this.getAccessibleTime()}`;
        announce(announceTimerMessage);
    }

    componentWillUnmount() {
        clearInterval(this.timer);
    }

    getAccessibleTime = () => {
        const hh = moment.duration(this.state.timeRemaining).get('hours');
        const mm = moment.duration(this.state.timeRemaining).get('minutes');
        const ss = moment.duration(this.state.timeRemaining).get('seconds');

        const hours = hh > 0 ? `${hh} ${pluralize(hh, 'hour', 'hours')}` : '';
        const minutes = mm > 0 ? `${mm} ${pluralize(mm, 'minute', 'minutes')}` : '';
        const seconds = ss > 0 ? `${ss} ${pluralize(ss, 'second', 'seconds')}` : '';

        return `${hours} ${minutes} ${seconds} remaining to complete the transactions in your cart`;
    }

    tick() {
        this.setState({
            timeRemaining: -1 * moment().diff(this.props.date)
        });
        if (this.state.timeRemaining <= 0) {
            if (this.props.onComplete) {
                this.props.onComplete();
            }
            clearInterval(this.timer);
        }
    }

    formatTime(num) {
        if (num <= 0) {
            return '00';
        }
        return num < 10 ? `0${num}` : num.toString();
    }

    formatAccessibleTime(num) {
        if (num <= 0) {
            return '';
        }
        return num;
    }

    renderTime() {
        const hh = this.formatTime(moment.duration(this.state.timeRemaining).get('hours'));
        const mm = this.formatTime(moment.duration(this.state.timeRemaining).get('minutes'));
        const ss = this.formatTime(moment.duration(this.state.timeRemaining).get('seconds'));

        let time = <time>{hh}:{mm}:{ss}</time>;

        // Hide hours if the remaining time is shorter than 60 minutes
        if (hh === '00') {
            time = <time>{mm}:{ss}</time>;
        }

        return time;
    }



    render() {
        return (
            <React.Fragment>
                <span className="rec-sr-only">{this.getAccessibleTime()}</span>
                <div className="rec-timer" aria-hidden="true">
                    <Icons.IconHourglassHalf />
                    {this.renderTime()}
                </div>
            </React.Fragment>
        );
    }
}

CartTimer.propTypes = propTypes;
